export default "__VITE_ASSET__DUwut5ZC__"